import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Factory, ShoppingCart, Heart, Briefcase, ArrowRight } from 'lucide-react';

const IndustriesSection = () => {
  const industries = [
    {
      icon: <Factory className="w-10 h-10" />,
      title: 'Manufacturing',
      description: 'Production tracking, quality control, and equipment management',
      link: '/industries/manufacturing',
      stats: '200+ Facilities'
    },
    {
      icon: <ShoppingCart className="w-10 h-10" />,
      title: 'Retail & E-commerce',
      description: 'Omnichannel inventory, order fulfillment, and demand forecasting',
      link: '/industries/retail',
      stats: '500+ Stores'
    },
    {
      icon: <Heart className="w-10 h-10" />,
      title: 'Healthcare',
      description: 'Medical asset tracking, compliance, and temperature monitoring',
      link: '/industries/healthcare',
      stats: '50+ Hospitals'
    },
    {
      icon: <Briefcase className="w-10 h-10" />,
      title: 'Logistics',
      description: 'Fleet management, route optimization, and real-time tracking',
      link: '/industries/logistics',
      stats: '100+ Warehouses'
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">Industries We Serve</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">Specialized solutions for diverse industry requirements</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => (
            <Card key={index} className="border-0 shadow-lg hover:shadow-2xl transition-all duration-300 group hover:-translate-y-2">
              <CardHeader>
                <div className="text-blue-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                  {industry.icon}
                </div>
                <CardTitle className="text-xl mb-2 group-hover:text-blue-600 transition-colors">{industry.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-slate-600 mb-4">{industry.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-blue-600">{industry.stats}</span>
                  <Link to={industry.link} className="text-blue-600 hover:text-blue-700">
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;